export { default as IllMCloud } from './ill-m-cloud.svg';
export { default as IllMServer } from './ill-m-server.svg';
export { default as IllXlSecure } from './ill-xl-secure.svg';
